<template>
    <div id="aqt_content">
      <div class="content_item">
        <div class="line line1"></div>
        <p class="title title_size1">{{aqt.title}}</p>
        <img :src="aqt.img1" class="img_one"/>
        <p class="title  title_size2">{{aqt.describe}}</p>
      </div>
      <div class="content_item">
        <div class="line line2"></div>
        <p class="title title_size1">{{aqt_msg.serve}}</p>
        <p class="title  title_size2">{{aqt_msg.serve_describe}}</p>
        <img :src="aqt_msg.serve_img" class="img_two"/>
        <div class="line line3"></div>
        <p class="title title_size3">{{aqt_msg.serve_offer}}</p>
          <div class="content_item_list" v-for="(list,index) in aqtArr" :key="index">
            <img :src="list.img" class="img_three"/>
            <div class="line line3"></div>
            <p class="title title_size1">{{list.title}}</p>
            <p class="title1 title_size2">{{list.describe}}</p>
          </div>
      </div>
      <div class="content_item" v-for="(list,index) in aqtArr2" :key="index" >
        <div class="line line2"></div>
        <p class="title title_size1">{{list.title1}}</p>
        <p class="title1  title_size2">{{list.title2}}</p>
        <img :src="list.img" class="img_two"/>

      </div>

    </div>

</template>

<script>

    export default {

      data(){
        return{
          aqt:{
            title:'强大的阿启泰团队，为您提供优质的互联网解决方案。',
            img1:require('../../assets/img/index1.png'),
            describe:'阿启泰团队自创立以来在IT领域为客户提供有竞争力、安全、可信赖的产品解决方案与服务。厚积薄发，逐梦同行。'
          },
          aqt_msg:{
            serve:'阿启泰服务',
            serve_describe:'通过与需求方沟通，了解所需服务，制定相关定制化服务。',
            serve_img:require('../../assets/img/index2.png'),
            serve_offer:'阿启泰团队，为您提供'
          },
          aqtArr:[
            {
              img:require('../../assets/img/index3.png'),
              title:'蒙汉APP小程序开发',
              describe:'为用户提供蒙汉app小程序开发服务',

            },
            {
              img:require('../../assets/img/index4.png'),
              title:'大数据平台建设',
              describe:'为用户提供大数据平台建设服务',

            },
            {
              img:require('../../assets/img/index5.png'),
              title:'蒙汉双语系统架构',
              describe:'为用户提供蒙汉双语系统架构服务',

            },
            {
              img:require('../../assets/img/index6.png'),
              title:'蒙汉双语数字化建设',
              describe:'为用户提供蒙汉双语数字化建设服务',

            },
            {
              img:require('../../assets/img/index7.png'),
              title:'蒙汉双语网站，公众号二次开发',
              describe:'为用户提供蒙汉双语网站，公众号二次开发服务',

            },

            {
              img:require('../../assets/img/index8.png'),
              title:'域名备案审核',
              describe:'为用户提供域名备案审核服务',

            },
          ],
          aqtArr2:[
            {
              title1:'阿启泰团队',
              title2:'内蒙古阿启泰科技有限公司在2016年2月成立于内蒙古自治区呼和浩特市，是由90后的年轻人员组成的互联网团队。阿启泰团队自创立以来在IT领域为客户提供有竞争力、安全、可信赖的产品解决方案与服务。持续为客户创造价值、释放团队潜能、激发组织创新、坚持稳中求胜、踏踏实实长期投入，厚积薄发。坚持以客户服务为中心，以奋斗者为本，长期艰苦奋斗，不断探索新技术。我们不会辜负时代赋予我们的历史性机遇，逐梦同行。',
              img:require('../../assets/img/index9.png'),

            },
            {
              title1:'阿启泰团队服务于各类行业',

              img:require('../../assets/img/index15.png'),

            }
          ]
        }
      },

      mounted(){

      }
    }
</script>

<style>
  #aqt_content{
    padding-top:4rem;
  }
  .content_item{
    width:90%;
    height:auto;
    margin-left:5%;
    position:relative;
  }
  .line{
    margin: 0 auto;
    width: 10%;
    height: 0.1rem;
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .line1{
    background-color: #F5A623;
  }
  .title{
    margin-left: 3rem;
    margin-right: 3rem;
    text-align:center;
    letter-spacing: 0.1rem;
  }
  .title_size1{
    font-size:1rem;
    color:#F4FAFF;
  }
  .img_one {
    width: 98%;
    margin-left: 1%;
    margin-top: 2rem;

    margin-bottom: 2rem;
  }
  .title_size2{
    font-size: 0.8rem;
    color:#D3DFFF;
    line-height:1.2rem;
    marign-top:1rem;
    margin-top: 1rem;
  }
  .line2{
    background-color:#26BFB9;
  }
  .img_two{
    width:74%;
    margin-top:1rem;
    margin-left:14%;
    margin-bottom:1rem;
  }
  .line3{
    background-color:#D03402;
  }
  .title_size3{
    color:#F4FAFF;
    font-size:1rem;

  }
  .img_three{
    width: 36%;
    margin-left: 32%;
    margin-top: 2rem;
  }


  .title1{
    margin-left: 0.5rem;
    letter-spacing:0.1rem;
    text-align: center;
  }


</style>
